import classes from "./Loader.module.css";
const Loader = () => {
  return (
    <div className={classes.container}>
      loading
    </div>
  );
};
export default Loader;
